module.exports = __webpack_public_path__ + "assets/img/cjm2.dc9c39ad.png";